import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CreditNoteService} from 'app/blocks/service/api/credit-note.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ICreditNote} from 'app/blocks/model/credit-note.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {CreditNote} from 'app/blocks/model/credit-note.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class CreditNoteResource extends AbstractEntityResource<ICreditNote> {
    constructor(creditNoteService: CreditNoteService, router: Router) {
        super(
            Resource.CREDIT_NOTES,
            creditNoteService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CREDIT_NOTES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CREDIT_NOTES),
            (entity?) => new CreditNote(entity),
            (entity) => entity.creditNoteNo,
            'description'
        );
    }
}
